import React from "react";
import mapPicture from "../assets/images/poster.jpg";


const Event = () => (
  <div className="row event">
    <div className="three columns header-col">
      <h1>
        <span>イベント概要</span>
      </h1>
    </div>

    {/* <div className="nine columns main-col">
      <div className="row item">
        <div className="twelve columns">
          <h5><span>メイン会場（道の駅 一向一揆の里）</span></h5>
          <p className="info">
            <em className="date">14:30 〜 16:00</em><span>&nbsp;</span>体験型ブース(うちわ、灯篭作り)<br />
            <em className="date">15:00 〜 21:00</em><span>&nbsp;</span>夜店<br />
            <em className="date">15:00 〜 18:00</em><span>&nbsp;</span>スタンプラリー(じもと ふしぎはっけん)<br />
            <em className="date">17:00 〜 17:30</em><span>&nbsp;</span>鳥越小学校 高学年合唱<br />
            <em className="date">17:00 〜 18:00</em><span>&nbsp;</span>追悼式<br />
            <em className="date">18:00 〜 19:00</em><span>&nbsp;</span>祭男〜綱引き〜<br />
            <em className="date">19:00 〜 19:30</em><span>&nbsp;</span>踊りの夕べ<br />
          </p>
          <h5><span>メイン会場横 特設会場</span></h5>
          <p className="info">
            <em className="date">14:30 〜 17:00</em><span>&nbsp;</span><strike>一向一揆 〜夏の陣〜（水風船合戦）<br /></strike>
            ※水風船ストラックアウトに変更になりました<br />
          </p>
          <h5><span>鳥越万灯華会場（であいふれあい公園）</span></h5>
          <p className="info">
            <em className="date">18:00 〜 21:00</em><span>&nbsp;</span>鳥越万灯華
            <p className="kome"> ※約1万本のろうそくの灯により幽玄の世界を演出します。</p>
          </p>
          <h5><span>二曲平野周辺</span></h5>
          <p className="info">
            <em className="date">20:00 〜 20:30</em><span>&nbsp;</span>北國花火大会<br />
            <p className="kome"> ※会場周辺であればどこからでもご覧いただけます。</p>
          </p>

          <h5><span>イベントポスター</span></h5>
          <p className="info">
            <p className="kome"> ※イベント参加随時募集中！<br />お問い合わせ先：一向一揆まつり事務局<br />TEL <a href="tel:000-1234-5678">076-254-2011</a><br />FAX 076-254-2305</p>
            <div className="columns image-item"><div className="item-wrap"><img alt="" src={mapPicture} /></div></div>
          </p>
        </div>
      </div>
    </div> */}
  </div>
);

export default Event;



// WEBPACK FOOTER //
// ./src/components/Event.js